import {useEffect, useState } from 'react';
import $ from 'jquery';
import { properties } from '../../properties';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';
import { getBasketCustomVars } from './BasketCustomVars';

function Validate({ apiUrl }) {
    const [validate, setValidate] = useState({
        operation: properties.OPERATIONS.validate,
        timestamp: "",
        transactionid: transidgenerator(),
        vendorid: properties.VENDOR_ID,
        password: properties.PASSWORD,
        method: properties.HTTP_METHOD,
        description: properties.DESCRIPTION,
        region: properties.SEL_REGION,
        address: properties.ADDRESS,
        postCode: properties.POST_CODE,
        countryCode: properties.COUNTRY_CODE,
        allowAvsFail: properties.ALLOW_AVS_FAIL,
        customerId: properties.CUSTOMER_ID,
        security: ""
    });
    
    const [isDpaFlag, setIsDpaFlag] = useState("false");

    var region =[];

    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    var canSubmit = true;
    
    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setValidate({ ...validate, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setValidate({ ...validate, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setValidate({ ...validate, password: e.target.value });
    }

    function changeDesc(e) {
        setValidate({ ...validate, description: e.target.value });
    }

    function changeAddr(e) {
        setValidate({ ...validate, address: e.target.value });
    }

    function changePostCode(e) {
        setValidate({ ...validate, postCode: e.target.value });
    }

    function changeCountryCode(e) {
        setValidate({ ...validate, countryCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setValidate({ ...validate, region: e.target.value });
    }

    function changeAllowAvsFail(e) {
        setValidate({ ...validate, allowAvsFail: e.target.value });
    }

    function changeCustomerId(e) {
        setValidate({ ...validate, customerId: e.target.value });
    }

    function changeDpaFlag(e) {
        setIsDpaFlag(e.target.value);
    }

    function onSubmitValidate(e) {
        e.preventDefault();
        isNotNullCheck(validate.password,"vendorPwd");
        isNotNullCheck(validate.vendorid,"WPG_vendorID");
        isNotNullCheck(validate.transactionid,"WPG_transID");
        isNotNullCheck(validate.region,"WPG_region");
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if(validate.region === "NoR"){
                setValidate({...validate, region:""});
            }
            $("#pwd").remove();
            var md5 = require('md5');
            var time = Math.floor(Date.now() / 1000);
            $("#validate_timestamp").val(time);
            var digest = md5(time + validate.vendorid + validate.transactionid + validate.method +
                validate.description + validate.region + validate.address + validate.postCode +
                validate.countryCode + validate.allowAvsFail + validate.password);
            $("#validate_security").val(digest);
            $("#validateForm").attr('action', apiUrl).submit();
        }
    }

    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

    var validateTemplate = (
        <div className="operation-form">
            <h2>Validate</h2>
            <form className="form-horizontal" method='post' id="validateForm" onSubmit={onSubmitValidate}>
                <input type="hidden" name="WPG_CUSTOM_Operation" value={validate.operation} />
                <input type="hidden" name="WPG_operation" value={validate.operation} />
                <input type="hidden" name="WPG_method" value={validate.method}/>
                <div className="form-group">
                    <div className="control-label">
                        Dpa Flag
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_dpaFlag" value={isDpaFlag} onChange={changeDpaFlag}>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={validate.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={validate.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group" id="pwd" >
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={validate.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={validate.description} onChange={changeDesc} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={validate.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Address
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_address" value={validate.address} onChange={changeAddr} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Postal/Zip Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_postcode" value={validate.postCode} onChange={changePostCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Country Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_countryCode" value={validate.countryCode} onChange={changeCountryCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Allow AVS Fail
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_allowAVSFail" value={validate.allowAvsFail} onChange={changeAllowAvsFail}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Customer Id
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_customerId" value={validate.customerId} onChange={changeCustomerId} />
                    </div>
                </div>
                <input type="hidden" name="WPG_timestamp" id="validate_timestamp" value="" />
                <input type="hidden" name="WPG_security" id="validate_security" value="" />
                {getBasketCustomVars()}
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" className="btn btn-primary">Continue</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>    
    );

    return validateTemplate;
}

export default Validate;